var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoctorTree(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 542.637,
    height: 752.786,
    viewBox: "0 0 542.637 752.786",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.e{fill:#1fa085;}.a,.c,.h{opacity:0.1;}.b{fill:#fff;}.d{fill:#cf6f80;}.f{fill:#3f3d56;}.g{fill:#512e4e;}.i{fill:#535461;}.j{fill:#9d9cb5;}.k{fill:none;stroke:#535461;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.485)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-22.48 -197.673)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 118.385,
    cy: 19.014,
    rx: 118.385,
    ry: 19.014,
    transform: "translate(327.861 912.431)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M491.8,519.4l-2.624,11.178s-21.019-10.728-24.809-24.36,6.342-18.807,6.342-18.807l19.585,8.3Z",
    transform: "translate(42.138 33.539)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M491.8,519.4l-2.624,11.178s-21.019-10.728-24.809-24.36,6.342-18.807,6.342-18.807l19.585,8.3Z",
    transform: "translate(42.138 33.539)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M398.123,834.681s-19.439,7.144-32.8,8.043c-7.1.474-10.825-3.876-12.745-8.067a24.419,24.419,0,0,1-2-7.35l1.737-19.257.923-10.254,28.393-7.375,4.022,12.3.377.936c1.616,4.107,8.092,20.812,7.9,24.3a6.634,6.634,0,0,0,1.993,4.8A11.555,11.555,0,0,0,398.123,834.681Z",
    transform: "translate(17.858 98.672)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M514.439,825.114a4.859,4.859,0,0,1-.17,1.737s-41.576,6.937-50.08,0a22.525,22.525,0,0,0-17.5-5.127s-16.086.437-18.771-4.86c-1.118-2.223-.826-6.536-.134-10.789a102.8,102.8,0,0,1,2.819-11.8l.644-.51,3.827-3.074,44.807-1.324h.34c-.219,9.161,15.211,19.67,15.211,19.67C511.827,815.115,514.245,821.979,514.439,825.114Z",
    transform: "translate(34.325 98.446)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M514.438,822.158a4.957,4.957,0,0,1-.182,1.737s-41.564,6.938-50.068,0a22.525,22.525,0,0,0-17.483-5.127s-16.1.437-18.771-4.86c-1.118-2.235-.838-6.536-.146-10.789,6.2.62,15.977,2.163,19.816,5.844,5.807,5.6,15.649,11.19,21.687,11.627C474.016,820.895,502.288,821.794,514.438,822.158Z",
    transform: "translate(34.326 101.402)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M397.766,827.181s-19.439,7.144-32.8,8.043c-7.1.474-10.825-3.876-12.733-8.079,4.945,1.665,11.809,3.414,15.418,1.81,4.277-1.9,19.439-3.122,27.944-3.645a11.963,11.963,0,0,0,2.175,1.871Z",
    transform: "translate(18.215 106.171)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M419.168,365.9c-16.037-6.233-36.667-26.826-31.516-36.449a21.528,21.528,0,0,0,2-7.727,70.557,70.557,0,0,0,.146-10.935A149.756,149.756,0,0,0,387.652,293s50.068,1.13,47.152,8.5c-.85,2.163-.984,5.917-.753,10.121s.838,8.954,1.47,12.976c.875,5.516,1.75,9.72,1.75,9.72s-3.062,4.289-4.86,4.52S442.18,374.779,419.168,365.9Z",
    transform: "translate(25.656 -8.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M385.685,803.651l-.377.413c-14.968-18.1-33.071,4.459-33.071,4.459l-.267-.474.923-10.254,28.393-7.375,4.021,12.3Z",
    transform: "translate(18.159 98.672)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M479.627,790.654s-10.935-.231-16.766,4.921-34.019,1.118-32.8,0a4,4,0,0,0,.632-1.847l3.827-3.074,44.807-1.324C479.493,790.144,479.627,790.654,479.627,790.654Z",
    transform: "translate(34.937 98.438)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M406.5,677.655a33.8,33.8,0,0,0-1.847,6.233,71.328,71.328,0,0,0-.838,17.69c.45,8.5,0,65.5,0,65.5s-9.61,15.2-14.968,20.557,10.935,14.98,10.935,14.98c2.43,13.851-12.3,29.5-12.3,29.5-14.968-18.1-33.071,4.471-33.071,4.471s-9.841-17.009-12.3-23.084,9.61-10.279,13.85-12.745-.207-17.009-.207-17.009-3.584-12.745-7.836-24.372,4.69-69.508,4.69-69.508.462-10.279,1.567-13.863a23.182,23.182,0,0,0,.328-7.873c-.073-.887-.158-1.628-.219-2.126s-.109-.729-.109-.729l.17-.292,6.075-11.323S409.414,670.523,406.5,677.655Z",
    transform: "translate(15.972 69.275)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M481.95,816.378s-10.935-.231-16.766,4.86-34.019,1.118-32.8,0,1.118-9.392,1.118-9.392c-16.535-22.574-2.43-31.735-2.43-31.735s-7.387-35.537-8.723-48.72c-.935-9.209-2.09-33.958-2.709-48.088-.267-6.075-.425-10.254-.425-10.254l13.51-2.721,1.737-.352,32.585-6.536s.9,6.075,1.507,11.044a51.638,51.638,0,0,1,.51,6.4c-.219,2.43,0,10.036,0,10.036l1.106,22.8a25.9,25.9,0,0,0-1.106,7.375c.219,2.9,4.459,44.479,4.459,44.479s7.375,24.809,4.86,26.6S481.95,816.378,481.95,816.378Z",
    transform: "translate(32.613 71.377)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M434.662,301.5c-.85,2.163-.984,5.917-.753,10.121a41.612,41.612,0,0,1-44.249-.826A149.742,149.742,0,0,0,387.51,293S437.578,294.106,434.662,301.5Z",
    transform: "translate(25.799 -8.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M456.957,285.256a41.15,41.15,0,0,1-2.041,12.891,41.576,41.576,0,0,1-81.086-11.894v-1a41.573,41.573,0,1,1,83.145,0Z",
    transform: "translate(22.858 -18.852)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M419.168,360.816c-16.037-6.233-36.667-26.826-31.516-36.449a21.528,21.528,0,0,0,2-7.727l21.954,18.042,13.583,11.141,10.327-26.292c.875,5.516,1.75,9.72,1.75,9.72s-3.062,4.289-4.86,4.52S442.18,369.7,419.168,360.816Z",
    transform: "translate(25.656 -3.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M431.368,382.265,413.034,690.255l-23.91,1.567L327.21,513.237l10.157-212.021,2.138-44.8,27.531,22.61,13.6,11.141,10.631-27.057,19.767,17.228Z",
    transform: "translate(70.231 55.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M404.3,677.638a33.8,33.8,0,0,0-1.847,6.233,176.166,176.166,0,0,1-50.129-15.661l-.328-.17.109-1.956.061-1.021,6.075-11.323S407.22,670.506,404.3,677.638Z",
    transform: "translate(18.166 69.292)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M433.013,680.6a123,123,0,0,1-13.437,1.531c-.267-6.075-.425-10.254-.425-10.254l13.51-2.721Z",
    transform: "translate(32.6 72.607)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M465.792,674.534c-8.638,2.248-21.978,4.775-33.921,3.2l-.17-7.7,32.585-6.536S465.184,669.5,465.792,674.534Z",
    transform: "translate(35.298 71.388)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M459.531,754.047c-49.813,8.5-95.435-15.879-95.435-15.879l.437-8.262s1.13-93.661-2-100.841-5.577-43.593-3.8-49.181-6.476-89.4-6.476-89.4l-1.336-34.019L302,436.652l21.869-45.585a164.5,164.5,0,0,0,7.606-19.682c3.8-11.834,21.456-23.461,21.456-23.461s18.1-11.615,25.259-11.178,16.535-10.278,16.535-10.278c6.925-17.653,13.194-9.659,13.194-9.659a15.771,15.771,0,0,1-.34,2.612c-2.43,19.378,39.292,80.612,39.887,81.693h0l3.973,96.783,4.021,122.479Z",
    transform: "translate(7.418 -3.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M458.437,754.06c-49.813,8.5-95.447-15.879-95.447-15.879l.45-8.262s1.13-93.661-2.017-100.841-5.577-43.593-3.791-49.181-6.476-89.4-6.476-89.4l-1.349-34.019L300.87,436.592l21.869-45.585a167.071,167.071,0,0,0,7.606-19.682c3.791-11.834,21.456-23.461,21.456-23.461s18.1-11.615,25.247-11.178,16.535-10.278,16.535-10.278c6.937-17.653,14.579-9.659,14.579-9.659,0,.838-.729,1.215-.34,2.612,5.346,18.8,37.955,80.612,38.55,81.693h0l4.021,96.783,4.021,122.479Z",
    transform: "translate(7.175 -3.533)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M427.629,403.315c-5.358-2.235-33.739-34.638-33.739-34.638V361.3c-1.033-2.43-7.168-.948-12.15.753l2.138-44.8,2.43,2.017C391.63,338.06,427.009,402.234,427.629,403.315Z",
    transform: "translate(24.559 -3.035)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M428.741,401.105c-5.37-2.236-33.751-34.638-33.751-34.638v-7.375c-1.033-2.43-7.168-.948-12.15.753l2.15-44.8,2.43,2.017C392.754,335.85,428.146,400.036,428.741,401.105Z",
    transform: "translate(24.795 -3.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M353.594,519.522c.668,0,34.638-3.572,34.638-3.572S408.8,556.4,407.453,566.237s-3.791,18.552-12.064,17.009-44.528,1.215-44.528,1.215Z",
    transform: "translate(17.921 39.674)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M352.484,517.312c.668,0,34.638-3.572,34.638-3.572s20.557,40.458,19.221,50.287-3.8,18.552-12.064,17.009-44.528,1.215-44.528,1.215Z",
    transform: "translate(17.683 39.198)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M376.357,501.05S407.532,517.8,408.2,522.919s-15.867-2.236-19.439-3.122a44.483,44.483,0,0,0-7.156-1.118l-23.825.644Z",
    transform: "translate(19.408 36.471)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 3.28,
    cy: 3.28,
    r: 3.28,
    transform: "translate(440.208 395.809)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.28,
    cy: 3.28,
    r: 3.28,
    transform: "translate(440.208 394.472)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 3.28,
    cy: 3.28,
    r: 3.28,
    transform: "translate(446.246 537.813)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.28,
    cy: 3.28,
    r: 3.28,
    transform: "translate(446.246 536.464)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 3.28,
    cy: 3.28,
    r: 3.28,
    transform: "translate(443.477 466.811)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.28,
    cy: 3.28,
    r: 3.28,
    transform: "translate(443.477 465.474)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M488.109,557.161s2.236,3.353,0,4.921.219,5.358.219,5.358-5.577,3.268-3.122,6.208.9,16.22.9,16.22l-6.706,11.1s.4,7.156.425,16.827c0,15.09-.887,36.3-5.8,45.974l.68,79.349s-23.485,8.578-43.143,5.965L428.65,621.76s4.252-72.2,5.82-86.055a144.2,144.2,0,0,0,1.118-21.687s-.668-21.675-2.916-31.735c0,0-2.43-43.58-2.673-55.645-.109-5.771.194-22.61.535-38.623.377-17.507.8-34.019.8-34.019L426.9,318.909s4.435-.45,5.771,1.336a12.792,12.792,0,0,0,1.944,1.494h0c7.654,5.176,34.7,21.092,34.7,21.092s14.968,5.953,18.552,14.482,6.075,14.579,7.812,17.009,2.685,13.85,2.685,13.85,5.151,21.019,9.173,24.578,6.962,26.207,6.962,26.207L478.961,466.9s-3.122,46.484-3.791,48.282S488.109,557.161,488.109,557.161Z",
    transform: "translate(34.266 -2.692)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M489.473,557.23s2.223,3.353,0,4.921.207,5.358.207,5.358-5.54,3.3-3.11,6.245.9,16.22.9,16.22l-6.707,11.1s.4,7.156.437,16.827c0,15.09-.887,36.3-5.8,45.974l.668,79.349s-23.521,8.578-43.155,5.965l-2.9-127.327s4.252-72.2,5.82-86.055a142.856,142.856,0,0,0,1.106-21.687s-.668-21.675-2.9-31.735c0,0-2.43-43.58-2.685-55.645-.109-5.771.207-22.61.535-38.623.377-17.508.8-34.019.8-34.019L426.83,318.54s5.856,0,7.2,1.81a11.528,11.528,0,0,0,1.944,1.494h0c7.654,5.176,34.711,21.092,34.711,21.092s14.956,5.953,18.54,14.482S495.3,372,497.054,374.428s2.673,13.85,2.673,13.85,5.151,21.019,9.173,24.579,6.925,26.158,6.925,26.158l-35.537,27.944s-3.122,46.484-3.8,48.282S489.473,557.23,489.473,557.23Z",
    transform: "translate(34.251 -2.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M446.675,363.946l3.208,9.355L432.994,390.31c.377-17.5.8-34.019.8-34.019L427.94,320.73s5.856,0,7.2,1.81a11.083,11.083,0,0,0,1.944,1.482h0l14.361,41.43Z",
    transform: "translate(34.489 -2.29)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M445.565,361.736l3.22,9.355L431.9,388.1c.377-17.508.8-34.019.8-34.019L426.83,318.52s5.868,0,7.2,1.81a12.153,12.153,0,0,0,1.944,1.494h0l14.373,41.418Z",
    transform: "translate(34.251 -2.764)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M456.957,285.256a41.15,41.15,0,0,1-2.041,12.891,1.737,1.737,0,0,1-1.312-.328c-.316-10.935-5.7-21.2-12.32-29.936a31.454,31.454,0,0,0-6.682-6.925,13.073,13.073,0,0,0-9.064-2.564c-3.645.5-6.864,2.977-10.546,3.293-4.86.4-9.209-2.965-14.033-3.135a13.79,13.79,0,0,0-10.315,4.787,28.3,28.3,0,0,0-5.528,10.254,60,60,0,0,0-3.086,17.69c-.061,3.4-.389,7.666-3.548,8.906a18.151,18.151,0,0,0-4.58-13.863l-.073-.073v-1a41.573,41.573,0,1,1,83.145,0Z",
    transform: "translate(22.858 -18.852)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M434.856,224.052a28.624,28.624,0,0,0-20.193-1.579c-3.365,1-6.536,2.612-9.95,3.426-7.29,1.762-15.794-.146-22.051,4.119-3.475,2.43-5.564,6.269-7.508,10l-4.86,9.258c-2.649,5.066-5.322,10.218-6.427,15.794s-.437,11.822,3.1,16.3c2.576,3.268,6.379,5.322,9.173,8.4a18.224,18.224,0,0,1,4.568,13.85c3.171-1.215,3.475-5.492,3.548-8.893a60,60,0,0,1,3.086-17.69,28.2,28.2,0,0,1,5.528-10.254,13.814,13.814,0,0,1,10.315-4.787c4.86.17,9.221,3.523,14.033,3.122,3.645-.3,6.877-2.794,10.546-3.28a13.025,13.025,0,0,1,9.064,2.564,31.127,31.127,0,0,1,6.67,6.925c6.634,8.736,12.016,18.978,12.332,29.936,1.373,1.008,3.353-.3,4.034-1.859s.7-3.378,1.567-4.86c1-1.713,2.9-2.624,4.4-3.912,3.791-3.268,4.738-8.772,4.593-13.765s-1.118-10.06-.17-14.968c.571-3.013,1.859-5.832,2.564-8.808s.79-6.318-.875-8.881c-2.43-3.766-7.545-4.507-12-4.86-5.066-.437-9.6.122-12.83-4.143a46.534,46.534,0,0,0-5.1-6.245C441.356,228.328,434.856,224.319,434.856,224.052Z",
    transform: "translate(20.611 -23.656)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M316.478,438.6l-12.7-23.473-4.022,36.218S302,467.434,301.546,469.9s9.161,24.578,9.161,24.578,31.747,56.544,44.71,59.46l43.8-31.3L387.6,507.892s-4.021-1.567-5.03,0c0,0-21.565-37.1-23.8-39.79s-1.8-8.043-1.8-8.043-3.353-3.572-2.236-6.925-6.476-14.98-6.476-14.98l6.925-6.476Z",
    transform: "translate(6.937 18.002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M304.925,412.93l-3.353,2.673-4.021,36.218s2.235,16.086,1.786,18.552,9.173,24.578,9.173,24.578,31.735,56.544,44.7,59.46l43.811-31.3-11.627-14.75s-4.021-1.567-5.03,0c0,0-21.565-37.1-23.8-39.79s-1.786-8.043-1.786-8.043-3.353-3.572-2.235-6.925-6.488-14.98-6.488-14.98l6.925-6.476Z",
    transform: "translate(6.462 17.529)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M479.375,533.538c2.43,2.952.9,16.208.9,16.208l-6.707,11.1s.4,7.168.425,16.827L462.717,581.2a6.694,6.694,0,0,1-8.687-6.6l1.944-62.7,26.3,10.06c-2.236,1.555.219,5.37.219,5.37S476.92,530.586,479.375,533.538Z",
    transform: "translate(40.097 38.803)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M480.487,532.426c2.43,2.952.9,16.22.9,16.22l-6.707,11.1s.4,7.156.437,16.827l-11.481,3.584a6.561,6.561,0,0,1-8.5-6.464l1.956-62.9L483.4,520.86c-2.248,1.555.207,5.358.207,5.358S478.057,529.486,480.487,532.426Z",
    transform: "translate(40.333 38.567)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M486.893,505.731s-1.786,11.408-6.257,12.077-6.476,18.455-10.935,17.823-1.507-16.536-1.349-19.622-4.86-15.867-1.106-18.771,15.636,0,15.636,0Z",
    transform: "translate(42.639 35.374)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M497.218,434.7l8.432-17.009S509,430.654,509,437.579s4.69,7.606,4.69,7.606,5.139,6.075,2.43,10.5-3.8,15.43-3.8,15.43.887,21.007-3.135,23.91-4.86,9.841-4.86,9.841-7.387,13.182-7.156,16.317-10.279,24.36-10.279,24.36,5.139-26.377-24.809-37.773c0,0-.231-8.954,2-11.408s5.722-3.572,3.536-15.977-.632-27.227-.632-30.2,6.706-21.541,6.706-21.541Z",
    transform: "translate(41.827 18.552)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M500.413,415.69l7.363,2.43s3.365,12.964,3.365,19.889,4.69,7.606,4.69,7.606,5.139,6.075,2.43,10.5-3.791,15.43-3.791,15.43.887,21.007-3.135,23.91-4.921,9.841-4.921,9.841-7.375,13.182-7.144,16.317-10.291,24.36-10.291,24.36,5.151-26.377-24.809-37.773c0,0-.219-8.954,2.017-11.408s5.722-3.572,3.536-15.977-.632-27.227-.632-30.2,6.707-21.541,6.707-21.541Z",
    transform: "translate(42.276 18.123)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M360.15,779.262s11.736-7.375,19.439-2.017S360.15,779.262,360.15,779.262Z",
    transform: "translate(19.918 95.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M435.21,759.8s10.388-1.336,19.111,8.055S435.21,759.8,435.21,759.8Z",
    transform: "translate(36.052 92.076)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(383.998 224.367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462.775,281.283c-1.494,1.288-3.414,2.211-4.41,3.924-.85,1.47-.875,3.28-1.555,4.86s-2.661,2.867-4.034,1.871c-.316-10.935-5.71-21.2-12.332-29.949a31.129,31.129,0,0,0-6.67-6.925A13.061,13.061,0,0,0,424.7,252.5c-3.645.5-6.852,2.977-10.534,3.28-4.86.413-9.221-2.952-14.045-3.122a13.753,13.753,0,0,0-10.3,4.8,28.138,28.138,0,0,0-5.528,10.242,60.066,60.066,0,0,0-3.086,17.69c-.073,3.39-.389,7.618-3.523,8.881a16.641,16.641,0,0,1,0,2.7c3.159-1.215,3.475-5.492,3.548-8.893a60,60,0,0,1,3.086-17.69,28.2,28.2,0,0,1,5.528-10.254,13.79,13.79,0,0,1,10.3-4.787c4.86.17,9.234,3.523,14.045,3.122,3.645-.3,6.877-2.794,10.534-3.28a13.061,13.061,0,0,1,9.076,2.564,31.128,31.128,0,0,1,6.67,6.925c6.622,8.736,12.016,18.978,12.332,29.936,1.373,1.008,3.353-.3,4.034-1.859s.7-3.378,1.555-4.86c1-1.713,2.916-2.624,4.41-3.912,3.791-3.268,4.738-8.772,4.593-13.765v-.462C467.161,274.078,466.007,278.488,462.775,281.283Z",
    transform: "translate(-360.312 -241.335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.16,278.714c-2.794-3.074-6.609-5.127-9.173-8.383a17.787,17.787,0,0,1-3.536-9.95A18.71,18.71,0,0,0,366.987,273c2.564,3.268,6.379,5.322,9.173,8.4a18.224,18.224,0,0,1,4.58,10.837,18.224,18.224,0,0,0-4.58-13.522Z",
    transform: "translate(-363.385 -239.629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454,245.706c-.717,2.977-1.993,5.807-2.576,8.808a28.058,28.058,0,0,0-.377,6.075,23.6,23.6,0,0,1,.377-3.45c.583-3.013,1.859-5.832,2.576-8.808a14.946,14.946,0,0,0,.4-5.03A16.88,16.88,0,0,1,454,245.706Z",
    transform: "translate(-344.548 -243.3)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.48 -197.673)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 118.385,
    cy: 19.014,
    rx: 118.385,
    ry: 19.014,
    transform: "translate(42.772 886.054)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M3.809,0h0A3.809,3.809,0,0,1,7.618,3.809V129.515a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V3.809A3.809,3.809,0,0,1,3.809,0Z",
    transform: "translate(157.354 582.826)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M240.795,646.569l-.474,7.727-.68,10.935-.279,4.544-.668,10.935-.292,4.544-.68,10.935L230.043,820.2a21.019,21.019,0,0,1-20.97,19.706H169.149A21.006,21.006,0,0,1,148.191,820.2l-7.642-124.1-.68-10.935-.279-4.544-.68-10.935-.279-4.544-.68-10.935-.486-7.727A10.935,10.935,0,0,1,148.4,634.93h81.657a10.862,10.862,0,0,1,10.74,11.639Z",
    transform: "translate(-27.953 65.249)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M193,592.24l-.68,10.9H91.26l-.68-10.9Z",
    transform: "translate(19.367 127.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M191.871,604.95l-.668,10.91H92.05l-.68-10.91Z",
    transform: "translate(19.537 130.037)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M190.741,617.68l-.668,10.9H92.84l-.68-10.9Z",
    transform: "translate(19.707 132.773)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M145.554,562.682c44.358,32.1,62.874,82.3,62.874,82.3s-53.458-1.835-97.828-33.934S47.75,528.76,47.75,528.76,101.184,530.583,145.554,562.682Z",
    transform: "translate(-47.233 42.427)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M47.72,528.76s55.5,30.8,73.3,56.3,87.416,59.921,87.416,59.921",
    transform: "translate(-47.24 42.427)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M161.239,506.727c24.141,17.459,34.237,44.783,34.237,44.783s-29.1-1-53.251-18.455S108,488.26,108,488.26,137.086,489.256,161.239,506.727Z",
    transform: "translate(-34.282 33.722)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M108,488.26s30.2,16.766,39.887,30.641,47.59,32.609,47.59,32.609",
    transform: "translate(-34.282 33.722)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M214.8,546.273c-27.737,30.483-33.606,70.321-33.606,70.321S220.3,607,248.012,576.5s33.606-70.322,33.606-70.322S242.533,515.79,214.8,546.273Z",
    transform: "translate(-18.55 37.573)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M281.642,506.19s-36.133,31.249-45.318,52.778-55.135,57.625-55.135,57.625",
    transform: "translate(-18.55 37.576)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorTree);
export default __webpack_public_path__ + "static/media/doctor-tree.4b03bc0249d0ce56e4c001ef521d7786.svg";
export { ForwardRef as ReactComponent };